export const rentItems = [
    "Thuê căn hộ chung cư",
    "Thuê văn phòng",
    "Thuê nhà riêng",
    "Thuê biệt thự, liền kề",
    "Thuê nhà mặt phố",
    "Thuê shophouse, nhà phố thương mại",
    "Thuê kho nhà xưởng, đất",
    "Thuê nhà trọ phòng trọ",
  ];
 export const saleItems = [
    "Bán căn hộ chung cư",
    "Bán văn phòng",
    "Bán nhà riêng",
    "Bán biệt thự, liền kề",
    "Bán nhà mặt phố",
    "Bán shophouse, nhà phố thương mại",
    "Bán kho nhà xưởng, đất",
    "Bán nhà trọ phòng trọ",
    "Bán trang trại, khu nghĩ dưỡng",
  ];